import Vue from "vue";
import Account from './Account/Account.vue'; 
import Billing from './Billing/Billing.vue'; 
import Bin from './Bin/Bin.vue'; 
import BrandingEdit from './BrandingEdit/BrandingEdit.vue'; 
import CollectForDownload from './CollectForDownload/CollectForDownload.vue'; 
import CollectionDetail from './CollectionDetail/CollectionDetail.vue'; 
import Collections from './Collections/Collections.vue'; 
import DesktopFiles from './DesktopFiles/DesktopFiles.vue'; 
import DesktopSpaces from './DesktopSpaces/DesktopSpaces.vue'; 
import Home from './Home/Home.vue'; 
import InviteAccepted from './InviteAccepted/InviteAccepted.vue'; 
import MobileAccount from './MobileAccount/MobileAccount.vue'; 
import MobileCollectionDetail from './MobileCollectionDetail/MobileCollectionDetail.vue'; 
import MobileCollections from './MobileCollections/MobileCollections.vue'; 
import MobileDownloadCollection from './MobileDownloadCollection/MobileDownloadCollection.vue'; 
import MobileFiles from './MobileFiles/MobileFiles.vue'; 
import MobileInviteAccepted from './MobileInviteAccepted/MobileInviteAccepted.vue'; 
import MobileLogin from './MobileLogin/MobileLogin.vue'; 
import MobileTransfer from './MobileTransfer/MobileTransfer.vue'; 
import MobileUpload from './mobileUpload/MobileUpload.vue'; 
import NoPage from './NoPage/NoPage.vue'; 
import NoPageMobile from './NoPageMobile/NoPageMobile.vue'; 
import NotificationsOverview from './NotificationOverview/NotificationsOverview.vue'; 
import PageWrapper from './PageWrapper/PageWrapper.vue'; 
import Plan from './Plan/Plan.vue'; 
import Policy from './Policy/Policy.vue'; 
import Pwa from './Pwa/Pwa.vue'; 
import SearchFull from './SearchFull/SearchFull.vue'; 
import Spaces from './Spaces/Spaces.vue'; 
import TermsEditor from './TermsEditor/TermsEditor.vue'; 
import TransferDownload from './TransferDownload/TransferDownload.vue'; 
import TransferDownloadMobile from './TransferDownloadMobile/TransferDownloadMobile.vue'; 
import Users from './Users/Users.vue'; 


const importAllVue = () => {
	Vue.component("account", Account); 
	Vue.component("billing", Billing); 
	Vue.component("bin", Bin); 
	Vue.component("branding-edit", BrandingEdit); 
	Vue.component("collect-for-download", CollectForDownload); 
	Vue.component("collection-detail", CollectionDetail); 
	Vue.component("collections", Collections); 
	Vue.component("desktop-files", DesktopFiles); 
	Vue.component("desktop-spaces", DesktopSpaces); 
	Vue.component("home", Home); 
	Vue.component("invite-accepted", InviteAccepted); 
	Vue.component("mobile-account", MobileAccount); 
	Vue.component("mobile-collection-detail", MobileCollectionDetail); 
	Vue.component("mobile-collections", MobileCollections); 
	Vue.component("mobile-download-collection", MobileDownloadCollection); 
	Vue.component("mobile-files", MobileFiles); 
	Vue.component("mobile-invite-accepted", MobileInviteAccepted); 
	Vue.component("mobile-login", MobileLogin); 
	Vue.component("mobile-transfer", MobileTransfer); 
	Vue.component("mobile-upload", MobileUpload); 
	Vue.component("no-page", NoPage); 
	Vue.component("no-page-mobile", NoPageMobile); 
	Vue.component("notifications-overview", NotificationsOverview); 
	Vue.component("page-wrapper", PageWrapper); 
	Vue.component("plan", Plan); 
	Vue.component("policy", Policy); 
	Vue.component("pwa", Pwa); 
	Vue.component("search-full", SearchFull); 
	Vue.component("spaces", Spaces); 
	Vue.component("terms-editor", TermsEditor); 
	Vue.component("transfer-download", TransferDownload); 
	Vue.component("transfer-download-mobile", TransferDownloadMobile); 
	Vue.component("users", Users); 

};

export default importAllVue;
